<template>
  <div :id="id" class="signature-pad">
    <!-- TODO: What if instead of text we can put an Icon that means Reset/Reload? -->
    <b-button @click="clearSignaturePad" class="signature-pad--btn">Reset</b-button>
    <VueSignaturePad height="250px" ref="signaturePadRef" :options="signatureOptions" />
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    name: String
  },
  data() {
    return {
      signatureOptions: {
        dotSize: (0.5 + 2.5) / 2,
        minWidth: 1,
        maxWidth: 2.5,
        throttle: 16,
        minDistance: 5,
        penColor: 'black',
        velocityFilterWeight: 0.7,
        onEnd: () => {
          this.emitSignatureInfo()
        }
      }
    }
  },
  methods: {
    emitSignatureInfo() {
      const signatureInfo = this.$refs.signaturePadRef.saveSignature()
      this.$emit('sign', this.name, signatureInfo)
    },
    clearSignaturePad() {
      this.$refs.signaturePadRef.clearSignature()
      this.emitSignatureInfo()
    }
  }
}
</script>

<style scoped>
.signature-pad {
  position: relative;
	background-color: #f0f0f0;
	width: 50%;
}

.signature-pad--btn {
  position: absolute;
  top: 32px;
  left: 80%;
  border-color: #c2deec;
  background: #fff;
  box-shadow: inset 0 1px 2px rgba(77, 77, 79, 0.1);
  opacity: 1;
  color: #4a4a4a;
}
</style>
